import { ContainerWithSidebarCards, SidebarCardData } from '../../Common/ContainerWithSidebarCards';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { InvoiceStatus } from '@cyberlabrs/helpers';
import { useHttpGetInvoicesOnMount } from '../../../hooks';

export interface FormValues {
    search: string;
    statuses: InvoiceStatus[];
}

export const InvoiceList = () => {
    const [elements, setElements] = useState<SidebarCardData[]>([]);
    const [selectedInvoice, setSelectedInvoice] = useState<SidebarCardData>({
        id: '',
        number: '',
        clientName: '',
        status: InvoiceStatus.DRAFT,
        total: 0,
        fileUrl: '',
        s3name: '',
    });

    const [queries, setQueries] = useState<FormValues>({
        search: '',
        statuses: [],
    });

    const initialInvoice = useLocation().state?.invoice;

    useEffect(() => {
        if (initialInvoice) {
            setSelectedInvoice(initialInvoice);
        }
    }, [initialInvoice]);

    const { data, loadMore, isLoading, hasMore, refetch } = useHttpGetInvoicesOnMount({
        mode: 'infinite',
        size: 16,
        search: queries.search || undefined,
        statuses: queries.statuses.length > 0 ? queries.statuses : undefined,
    });

    useEffect(() => {
        if (selectedInvoice.id && !selectedInvoice.fileUrl) {
            setSelectedInvoice(elements.find(inv => inv.id === selectedInvoice.id) || selectedInvoice);
        }
    }, [selectedInvoice, elements]);

    useEffect(() => {
        refetch();
    }, [queries]);

    useEffect(() => {
        const mappedData = data.map(invoice => ({
            id: invoice.id,
            number: invoice.number,
            clientName: invoice.clientName,
            status: invoice.status,
            total: invoice.total,
            fileUrl: invoice.fileUrl,
            s3name: invoice.s3name,
        }));
        setElements(mappedData);
    }, [data]);

    return (
        <div className="invoice-list">
            <div className="invoice-list__content">
                <ContainerWithSidebarCards
                    loadMore={loadMore}
                    hasMore={hasMore}
                    isLoading={isLoading}
                    elements={elements}
                    setSelectedInvoice={setSelectedInvoice}
                    selectedInvoice={selectedInvoice}
                    setQueries={setQueries}
                />
            </div>
        </div>
    );
};
